import React, { useEffect, useMemo, useRef } from 'react'
import classNames from 'classnames'
import { createFromIconfontCN } from '@ant-design/icons'
import './index.less'

// 跨境icon
const Icon = createFromIconfontCN({
  scriptUrl: [
    // 对应iconfont【美念】项目
    '//at.alicdn.com/t/c/font_4013419_ypxcwf2v5z.js',
    // 对应iconfont【跨境（新）】项目
    '//at.alicdn.com/t/c/font_5052219_z038xw67ra8.js',
    // 对应iconfont【知衣跨境】项目
    '//at.alicdn.com/t/c/font_2826226_nv4te50do3f.js',
    // 对应iconfont【AI改款点数】项目
    '//at.alicdn.com/t/c/font_2271401_qnb2jnnldo.js',
    // 对应iconfont【AI数据】项目
    '//at.alicdn.com/t/font_1133761_tnym7seiypp.js',
  ],
})

Icon.Zhuxiala = ({ icon = 'zykj-zhuxiala1', className, style, ...otherProps }) => (
  <Icon
    type={icon}
    className={className}
    style={{
      marginLeft: '4px',
      transition: 'transform 0.3s ease 0.1s',
      fontSize: '16px',
      ...style,
    }}
    {...otherProps}
  />
)

Icon.Wenti = ({ icon = 'zykj-shuomingwenti', className, style, ...otherProps }) => (
  <Icon
    type={icon}
    className={className}
    style={{
      marginLeft: '4px',
      fontSize: '14px',
      color: 'var(--color-text-second)',
      cursor: 'pointer',
      ...style,
    }}
    {...otherProps}
  />
)

Icon.Image = ({ type, url, hoverUrl, style, className, size = 14, isHover = false, isActive = false, ...otherProps }) => {
  const ref = useRef()
  const options = {
    1688: {
      url: 'https://cdn.zhiyitech.cn/material/81f5b1e06a86020039e037a725cf7ffe',
      hoverUrl: 'https://cdn.zhiyitech.cn/material/9b335d4a4917ae0caec062c3f4b9e56a',
    },
    ins: {
      url: 'https://cdn.zhiyitech.cn/material/64207673d10f62aeb90126d23ab5b814',
      hoverUrl: 'https://cdn.zhiyitech.cn/material/6cca188717365433963dbd2cb2be02ed',
    },
    tiktok: {
      url: 'https://cdn.zhiyitech.cn/material/07ebbaa7a63113b2b84e1f57907ceb5c',
      hoverUrl: 'https://cdn.zhiyitech.cn/material/b2e1735debb8f4866cbea191fafc82c8',
    },
    amazon: {
      url: 'https://cdn.zhiyitech.cn/material/ce6a4a6dfd76067363122f0385d2f7d1',
      hoverUrl: 'https://cdn.zhiyitech.cn/material/26c460e65b1455fc60f54f2fcfc5ed7d',
    },
    ltk: {
      url: 'https://cdn.zhiyitech.cn/material/861bd44eaef0196bcd6b949dd753b14c',
      hoverUrl: 'https://cdn.zhiyitech.cn/material/07aec7f94f0eab5937c82a73c78c396a',
    },
    pinterest: {
      url: 'https://cdn.zhiyitech.cn/material/de06104512a17f80b9b52cb3fe8cab8b',
      hoverUrl: 'https://cdn.zhiyitech.cn/material/ab23ad10a74f52e6fde75ecf8c668bbe',
    },
    linkTree: {
      url: 'https://cdn.zhiyitech.cn/material/df587a4456398ac682a46bfdc392be38',
      hoverUrl: 'https://cdn.zhiyitech.cn/material/06e55490f208f874c67653ce9a62a6eb',
    },
    whatsapp: {
      url: 'https://cdn.zhiyitech.cn/material/8ae03cd3227dbdae407141faee650694',
      hoverUrl: 'https://cdn.zhiyitech.cn/material/ba92f6126febe0bf1f87a35b392b609e',
    },
  }

  const config = useMemo(() => {
    if (type) {
      return options[type]
    }
    return {
      url,
      hoverUrl,
    }
  }, [url, hoverUrl, type])

  useEffect(() => {
    ref?.current?.style.setProperty('--iconImageUrl', `url(${config.url})`)
    ref?.current?.style.setProperty('--iconImageHoverUrl', `url(${config.hoverUrl})`)
  }, [config])

  return (
    <span ref={ref} style={style} className={classNames('iconImageWrap', className, { isHover, isActive })} {...otherProps}>
      <div className="iconImage" style={{ width: size, height: size }} />
    </span>
  )
}

export default Icon
